module.exports = __webpack_public_path__ + "img/bg-main.a6171927.jpg";